import React from "react";
import { object } from "prop-types";
import { Link } from "@quintype/components";

import { getSiteLink } from "../../utils/utils";
import { staticTexts } from "../../utils/Translate";

import "./languageEdition.m.css";

function LanguageEdition({ publisherAttributes }) {
  return (
    <div styleName={`${publisherAttributes.lang}-version-container version-container`}>
      <Link aria-label="language edition link" href={getSiteLink(publisherAttributes)}>
        <span styleName="current-language">{publisherAttributes.lang === "bn" ? "English" : "বাংলা"}</span>
      </Link>
      <label styleName="version-label">
        {publisherAttributes.lang === "bn" ? staticTexts("en").edition : staticTexts().edition}
      </label>
    </div>
  );
}

LanguageEdition.propTypes = {
  publisherAttributes: object,
};

export default LanguageEdition;
